import React from 'react';
import AvatarGroupBuilder from '../components/AvatarGroupBuilder';

export default function EditAvatarGroup() {
  return <AvatarGroupBuilder mode="edit" />;
}
